import { ethers } from 'ethers';
import { getRpcUrl } from './address';

export const getProviderCompat = () => {
  if (typeof window !== 'undefined' && window.ethereum) {
    return new ethers.BrowserProvider(window.ethereum);
  }
  const rpcUrl = getRpcUrl();
  if (rpcUrl) {
    return new ethers.JsonRpcProvider(rpcUrl);
  }
  return null;
};

export const getSignerCompat = async () => {
  if (typeof window !== 'undefined' && window.ethereum) {
    await window.ethereum.request({ method: 'eth_requestAccounts' });
    const provider = new ethers.BrowserProvider(window.ethereum);
    return provider.getSigner();
  }
  return null;
};

